<template>
  <div class="modal-product-sizes-and-measurements">
    <fn-modal
      :headline-text="$t('product.sizesAndMeasurements.title')"
      full-width-header-divider
      max-width="xl"
      @close="$emit('close')"
    >
      <div class="mpsam-container">
        <fn-paragraph medium>
          {{ $t('product.sizesAndMeasurements.modal.description') }}
        </fn-paragraph>

        <template v-if="!!sizeTable?.length">
          <div class="mpsam-table-container">
            <fn-headline
              type="h5"
              same-size-mobile
            >
              {{ $t('product.sizesAndMeasurements.modal.sizeTableTitle') }}
            </fn-headline>

            <fn-product-sizes-and-measurements-table :input-table="sizeTable" />
          </div>
        </template>

        <template v-if="!!sizeTableMeasurement?.length">
          <div class="mpsam-table-container">
            <fn-headline
              type="h5"
              same-size-mobile
            >
              {{ $t('product.sizesAndMeasurements.modal.bodyMeasurementTableTitle') }}
            </fn-headline>

            <fn-product-sizes-and-measurements-table
              :input-table="sizeTableMeasurement"
              show-heading-asterisks
              show-reference
            />
          </div>
        </template>

        <template v-if="!!Object.keys(measurementsInfo || {}).length">
          <fn-headline
            type="h5"
            same-size-mobile
          >
            {{ $t('product.sizesAndMeasurements.modal.howToMeasure.title') }}
          </fn-headline>

          <div class="mpsam-how-to-measure">
            <div
              v-if="showImage"
              class="htm-image"
            >
              <fn-picture
                :src="measurementsInfo.media.url"
                :alt="measurementsInfo.media.code"
                :lazy="false"
                fetchpriority="high"
              />
            </div>
            <div
              v-if="!!measurementsSteps?.length"
              class="htm-content"
            >
              <div
                v-for="(step, index) of measurementsSteps"
                :key="`measure-step-${step.title}-${index}`"
                class="htm-measure-step"
              >
                <span class="htm-title">{{ step.title }}</span>
                <span class="htm-description">{{ step.description }}</span>
              </div>
            </div>
          </div>
        </template>
      </div>
    </fn-modal>
  </div>
</template>

<script>
export default defineComponent({
  props: {
    sizeTable: {
      type: Array,
      default: () => [],
    },
    sizeTableMeasurement: {
      type: Array,
      default: () => [],
    },
    measurementsInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['close'],
  computed: {
    showImage() {
      return this.measurementsInfo?.media?.url;
    },
    measurementsSteps() {
      const measureCode = this.measurementsInfo?.code;
      if (!measureCode) {
        return [];
      }
      return this.$t(`product.sizesAndMeasurements.modal.howToMeasure.${measureCode}.steps`);
    },
  },
});
</script>

<style lang="scss" scoped>
.modal-product-sizes-and-measurements {
  :deep(.modal) {
    .headline-wrapper {
      position: unset;
    }
  }

  .mpsam-container {
    display: flex;
    flex-direction: column;
  }

  .mpsam-table-container {
    margin-bottom: 2 * $pad;
  }

  .mpsam-how-to-measure {
    display: flex;
    align-items: flex-start;
    gap: $pad;

    .htm-image {
      flex: 1;
      min-height: 238px;
    }

    .htm-content {
      flex: 2;
      display: flex;
      flex-direction: column;

      .htm-measure-step {
        display: flex;
        flex-direction: column;
        gap: math.div($pad, 4);
        margin-bottom: $pad;

        &:last-child {
          margin-bottom: 0;
        }
      }

      .htm-title,
      .htm-description {
        font-size: map-get($font-sizes, m);
      }

      .htm-title {
        font-weight: map-get($font-weights, bold);
      }
    }

    @include bp(m, max) {
      flex-direction: column;

      .htm-image {
        align-self: center;

        :deep(.picture img) {
          max-width: 310px;
          max-height: 268px;
        }
      }
    }
  }

  :deep(.m-content) {
    .p {
      margin-bottom: 2 * $pad;
    }
  }
}
</style>
